import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import TokenResponse from './types/TokenResponse';

function removeTokens(): void {
	Cookies.remove('accessToken');
	Cookies.remove('refreshToken');
}

function setAccessToken(token: string): void {
	const isSecure = window.location.protocol === 'https:';

	Cookies.set('accessToken', token, {
		expires: 1 / 12,
		secure: isSecure,
		sameSite: 'strict',
	});
}

async function refreshAccessToken(refreshToken: string): Promise<string> {
	const res = await axios.post<TokenResponse>(`${API_BASE_URL}/api/auth/token`, {
		refreshToken,
	});

	const newAccessToken = res.data.accessToken;
	setAccessToken(newAccessToken);

	return newAccessToken;
}

export const axiosDefault = axios.create({
	headers: {
		'Content-Type': 'application/json',
		accept: 'application/json',
	},
});

export const axiosWithAuth = axios.create({
	headers: {
		'Content-Type': 'application/json',
		accept: 'application/json',
	},
});

axiosWithAuth.interceptors.request.use(async (config) => {
	try {
		const refreshToken = Cookies.get('refreshToken');
		let accessToken = Cookies.get('accessToken');

		if (!refreshToken) {
			removeTokens();
			return config;
		}

		if (!accessToken) {
			accessToken = await refreshAccessToken(refreshToken);
		} else {
			const decoded: { exp?: number } = jwtDecode(accessToken);
			const nowInSeconds = Math.floor(Date.now() / 1000);

			if (decoded.exp && decoded.exp - nowInSeconds < 10) {
				accessToken = await refreshAccessToken(refreshToken);
			}
		}

		if (config.headers && accessToken) {
			config.headers.Authorization = `Bearer ${accessToken}`;
		}

		return config;
	} catch (error) {
		removeTokens();
		return Promise.reject(error);
	}
});
